import cl from 'classnames'
import { Modal } from '../Modal'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentLanguage } from '@/i18next'
import { DigitalSign } from '@/utils/digitalSign'
import { nominationThunks, NOMINATION_DTSP_FIELDS } from '@/entity/nomination'
import { LANGUAGE_ENUM } from '@/shared'
import { Button, Radio } from '@/ui'
import { Divider } from '@/components/Divider/Divider'
import { Formik, Form } from 'formik'
import { CategoryArrayField } from '@features/nomination/Dtsp/CategoryArrayField'
import { message } from 'antd'

const NOMINATED_TYPE = {
	total: 'total',
	category: 'category'
}

export const CreateModal = ({onClose, item, onSuccess}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()
	const formRef = useRef(null)

	const digitalSign = new DigitalSign()

	const [nominatedType, setNominatedType] = useState(NOMINATED_TYPE.total)

	const { dictNomination } = useSelector((state) => ({
		dictNomination: state.nomination.dictNomination,
	}))

	useEffect(() => {
		if (!dictNomination?.success) dispatch(nominationThunks.getDictNomination())
	}, [])


	let nomination = dictNomination?.data?.find(i => i.code === item.nominationCode)

	let title = {
		[LANGUAGE_ENUM.kz]: nomination?.nameKz,
		[LANGUAGE_ENUM.rus]: nomination?.nameRu,
	}

	const radioOptions = [
		{
			code: NOMINATED_TYPE.total,
			nameRu: t('nomination.total_list'),
			nameKz: t('nomination.total_list'),
		},
		{
			code: NOMINATED_TYPE.category,
			nameRu: t('nomination.by_category_list'),
			nameKz: t('nomination.by_category_list'),
		}
	]

	const handleSign = async (xmlData) => {
		const xml = await digitalSign.handleSend(xmlData)

		let xmlBody = {
			data: {
				xmlData: xml,
			},
			onSuccess: (res) => {
				onSuccess()
				message.success(t('reviews.success_payload'))
			},
		}

		dispatch(nominationThunks.setDtspReportSign(xmlBody))
	}

	const handleSubmit = (data) => {
		let body = {
			data: {
				nominationCode: item.nominationCode,
				year: item.year,
				byCategory: nominatedType !== NOMINATED_TYPE.total,
				largeCategoryPlaces: data?.largeCategoryPlaces?.filter(i => i.orgBin)?.map((i, idx) => ({...i, place: idx + 1})),
				smallCategoryPlaces: data?.smallCategoryPlaces?.filter(i => i.orgBin)?.map((i, idx) => ({...i, place: idx + 1})),
			},
			onSuccess: async ({ xmlData }) => {
				await handleSign(xmlData)
			},
		}

		dispatch(nominationThunks.setDtspReportXml(body))
	}

	const formRender = useMemo(() => {
		const content = {
			[NOMINATED_TYPE.total]: <CategoryArrayField name={NOMINATION_DTSP_FIELDS.largeCategoryPlaces} item={{...item, subjectCategoryCodes: ['s', 'm', 'l']}}/>,
			[NOMINATED_TYPE.category]: (
				<div>
					<div className={cl('mb-2')}>
						<span>
						{t('nomination.large_orgs')}
						</span>
					</div>
					<CategoryArrayField name={NOMINATION_DTSP_FIELDS.largeCategoryPlaces} item={{...item, subjectCategoryCodes: ['l']}}/>
					<Divider />
					<div className={cl('mb-2')}>
						<span className={cl('mb-3')}>
							{t('nomination.small_orgs')}
						</span>
					</div>
					<CategoryArrayField name={NOMINATION_DTSP_FIELDS.smallCategoryPlaces} item={{...item, subjectCategoryCodes: ['s', 'm']}}/>
				</div>
			),
		}

		return content[nominatedType] || null
	}, [nominatedType])

	return (
		<Modal onClose={onClose}>
			<h3 className={cl('fw-bold', 'mb-5')}>
				{t('nomination.form_doc')}
			</h3>

			<h2 className={'mb-5'}>
				{title[lang] || ''}
			</h2>

			<div className={cl('my-3')}>
				<span>
					{t('nomination.nominated_orgs')}
				</span>
				<Radio options={radioOptions} value={nominatedType} onChange={(e) => setNominatedType(e.target.value)} />
			</div>

			<Divider />

			<Formik
				onSubmit={handleSubmit}
				initialValues={{}}
				innerRef={formRef}
			>
				{({ values, errors }) => {
					return (
						<Form>
							<div className={cl('mb-4')}>
								{formRender}
							</div>

							<div className={cl('flex', 'align-items-center', 'justify-content-end', 'gap-5')}>
								<Button type='bare' onClick={onClose}>
									{t('cancel')}
								</Button>

								<Button type='submit'>
									{t('nomination.sign_form_doc')}
								</Button>
							</div>
						</Form>
					)
				}}
			</Formik>
		</Modal>
	)
}